// extracted by mini-css-extract-plugin
export var emailBlockLink = "_h8-0";